import React, { FC, useState } from 'react'
import { useParams } from 'react-router-dom'
import { PageTitleSection } from '../../components/common/ui/PageTitleSection'
import { ReclamationForm } from '../../components/forms/ReclamationForm'
import CustomModal from '../../components/modal/CustomModal'
import { NEW_RECLAMATION } from '../../constants/routes'
import { useClientsDetails } from '../../hooks/clientDetails/UseClientDetails'
import ClientInfo from '../../components/common/ui/ClientInfo'

const NewReclamation: FC = () => {
  const { clientId } = useParams<{ clientId: string }>()
  const clientDetailsData = useClientsDetails(clientId)?.clientDetailsData
  const { name, cipCode } = clientDetailsData
  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <section className="pageContentWrapper dashboardPage pl75">
      <div className="px3 py3">
        <PageTitleSection pageName={NEW_RECLAMATION}>
          <ClientInfo name={name} code={cipCode} />
        </PageTitleSection>
        <div className="reclamationFormWrapper withBackgroundColorDefault hasBorderRadius px2 py2">
          <ReclamationForm
            setIsModalOpen={setIsModalOpen}
            clientDetailsData={clientDetailsData}
          />
        </div>
      </div>
      <CustomModal isModalOpen={isModalOpen} />
    </section>
  )
}

export default NewReclamation
